<template>
  <div class="input-container" :class="{ 'input-container--focused': inputFocused }">
    <label
      v-if="!inputFocused && !data"
      class="v-label"
      style="left: 12px; top: 10px; position: absolute; pointer-events: none; color: #00000099"
      :class="{ 'error--text': !!errorText }"
      >{{ label || 'HH:mm' }}
    </label>
    <MaskedInput
      v-bind="this.$attrs"
      v-model="data"
      mask="11:11"
      class="input"
      @focus.native="inputFocused = true"
      @blur.native="inputFocused = false"
      :class="{ 'input--error': !!errorText, 'input--clearable': clearable }"
    />
    <button
      v-if="clearable && data"
      type="button"
      class="clear-button"
      tabindex="-1"
      @mousedown.prevent
      @click="clear"
    >
      <v-icon>mdi-close</v-icon>
    </button>
    <VMessages v-if="errorText" class="caption error--text pl-3 error-text" :value="[errorText]" color="error" />
  </div>
</template>

<script>
import { buildHoChiMinhDateTimeISOString, formatHoChiMinhDate, formatHoChiMinhTime } from '@/helpers/dateTime'
import MaskedInput from 'vue-masked-input'
import VInput from 'vuetify/lib/components/VInput/VInput.js'

const TIME_VALUE_FORMAT = /^\d{2}:\d{2}$/

export default {
  extends: VInput,
  components: {
    MaskedInput,
  },
  props: {
    date: String,
    selectedDate: String,
    label: String,
    returnTime: {
      type: Boolean,
      default: false
    },
    clearable: Boolean
  },
  data: () => ({
    data: '',
    menu: false,
    errorText: '',
    isRule: false,
    inputFocused: false
  }),

  methods: {
    validate(force) {
      // overide validate VInput
      if (force) {
        this.updated(this.data)
      }
      return !this.errorText
    },
    setIsRule(status) {
      this.isRule = status
    },
    formatTimeValue(value) {
      if (!value) return ''
      if (TIME_VALUE_FORMAT.test(value)) return value
      return formatHoChiMinhTime(value)
    },
    buildDateTime(value) {
      const selectedDate = this.selectedDate || formatHoChiMinhDate('', true)
      return buildHoChiMinhDateTimeISOString(selectedDate, value)
    },
    emitValue(value) {
      const output = this.returnTime ? value : this.buildDateTime(value)
      this.$emit('update:date', output)
      this.$emit('input', output)
    },
    updated(value) {
      if (value === '__:__') value = ''
      if (this.rules && this.rules.length && this.isRule) {
        let errorText = ''
        for (const rule of this.rules) {
          errorText = rule(value)
          if (errorText !== true) break
        }
        if (errorText !== true) this.errorText = errorText
        else this.errorText = null
      }
      if (value) {
        if (!this.errorText) {
          this.emitValue(value)
        }
      } else {
        this.$emit('update:date', '')
        this.$emit('input', '')
      }
      this.menu = false
    },
    reset() {
      if (this.date) {
        this.data = this.formatTimeValue(this.date)
      } else {
        this.data = ''
      }
    },
    clear() {
      this.data = ''
      this.errorText = ''
      this.isRule = false
      this.$emit('update:date', '')
      this.$emit('input', '')
    },
  },
  created() {
    this.reset()
  },
  watch: {
    isRule() {
      if (!this.isRule) {
        this.errorText = ''
      }
    },
    data(value) {
      if (value.length === 5) {
        this.isRule = true
        this.updated(this.data)
      }
    },
    date(value) {
      if (value) {
        const time = this.formatTimeValue(value)
        if (time !== this.data) this.data = time
        this.updated(time)
      } else {
        this.data = ''
        this.updated('')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  position: relative;
}
.input {
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 4px;
  outline: none;
  padding: 7px 8px;
  box-sizing: border-box;
}

.input:focus {
  border: 2px solid #0d47a1;
  padding: 6px 7px;
}

.input--clearable {
  padding-right: 32px !important;
}

.input--clearable:focus {
  padding-right: 31px !important;
}

.clear-button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #757575;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.input-container:hover .clear-button,
.input-container--focused .clear-button {
  opacity: 1;
  pointer-events: auto;
}

.input-container--focused .clear-button {
  color: #0d47a1;
}

.clear-button .v-icon {
  color: currentColor;
}

.input--error {
  border: 2px solid #b71c1c !important;
  padding: 6px 7px;
}
.error-text {
  margin-top: 4px;
  min-height: 14px;
  line-height: 14px;
  position: absolute;
  white-space: nowrap;
}
</style>
